var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoadingIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 86.4 128",
    enableBackground: "new 0 0 86.4 128",
    xmlSpace: "preserve",
    className: "loader",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    width: 86.4,
    height: 128
  })), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M43.2,128C19.4,128,0,108.6,0,84.8C0,61,19.4,41.6,43.2,41.6             C67,41.6,86.4,61,86.4,84.8C86.4,108.6,67,128,43.2,128 M43.2,50.5c-18.9,0-34.3,15.4-34.3,34.3s15.4,34.3,34.3,34.3             c18.9,0,34.3-15.4,34.3-34.3S62.1,50.5,43.2,50.5"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M44,32.5c16.3,0,27.1,7.2,37.3,18.4L85.5,0c0,0-11.5,19.7-20.9,19.8             C55.2,19.9,44.1,0,44.1,0S33.7,19.9,23.7,19.8C13.6,19.7,2.6,0,2.6,0l3.2,49.2C15.9,38,27.8,32.5,44,32.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "svg-seconds-hand",
    fill: "currentColor",
    d: "M46.5,86.2c0,1.4-1.1,2.5-2.5,2.5h-2.7c-1.4,0-2.5-1.1-2.5-2.5V59.9 c0-1.4,1.1-2.5,2.5-2.5H44c1.4,0,2.5,1.1,2.5,2.5V86.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "svg-minutes-hand",
    fill: "currentColor",
    d: "M46.5,86.2c0,1.4-1.1,2.5-2.5,2.5h-2.7c-1.4,0-2.5-1.1-2.5-2.5V65 c0-1.4,1.1-2.5,2.5-2.5H44c1.4,0,2.5,1.1,2.5,2.5V86.2z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoadingIcon);
export default __webpack_public_path__ + "static/media/loading-icon.7235159d8e2dc7b5e8f92ec52ec84cf9.svg";
export { ForwardRef as ReactComponent };